import React, { forwardRef } from 'react'
import { StyleSheet } from 'react-native'
import { Input } from '@ui-kitten/components'

export default forwardRef(function StyledTextInput( { style, inputStyle=null, caption=null, value, controlledInput=false, disabled=false, ...otherProps }, ref) {
  return (
    <Input
      ref={ref}
      style={[style, inputStyle]}
      autoCorrect={false}
      defaultValue={controlledInput ? undefined : value}
      value={controlledInput ? value : undefined}
      caption={caption}
      disabled={disabled}
      {...otherProps}
    />
  )
})